import { useQuery, UseQueryOptions } from 'react-query';
import client from 'client';

export type SessionRegistrationSettings = {
    settings: {
        allowOverlappingRegistration: boolean;
        capacityLimit: 'Limited' | 'Restricted' | 'Custom';
        capacityLimitCustom: string;
        capacityLimitEnabled: boolean;
        capacityLimitReached: 'Full' | 'Max capacity' | 'Custom';
        capacityLimitReachedEnabled: boolean;
        capacityUnlimit: 'Open for all' | 'Unrestricted' | 'Unlimited' | 'Custom';
        capacityUnlimitEnabled: string;
    };
};
const defaultLimitLabels = {
    capacityUnlimit: 'Open for all',
    capacityLimit: 'Limited',
    capacityLimitReached: 'Full',
};

const fetchSessionRegistrationSettings = async (eventId: number) => {
    const response = await client().get<SessionRegistrationSettings>(
        `/api/v2/agenda/events/${eventId}/sessionRegistration`
    );

    return {
        settings: {
            ...defaultLimitLabels,
            ...response.data?.settings,
        },
    };
};

const useSessionRegistrationSettings = <TData = SessionRegistrationSettings>(
    eventId: number,
    options?: UseQueryOptions<SessionRegistrationSettings, Error, TData>
) => {
    return useQuery(
        'session_registration_settings',
        () => fetchSessionRegistrationSettings(eventId),
        options
    );
};

export default useSessionRegistrationSettings;
